module.exports = __webpack_public_path__ + "img/acid-projectile-purple.59481ba8.png";